import { MacStageKey } from '@models/MacDetails';

// Geometry and palette mirror the MAC Admin editor graphic (menu-trends-admin-ui macCanvas.ts / theme.ts).
export const MAC_CANVAS_WIDTH = 960;

export const MAC_CURVE_PATH =
    'M0.421631 382C24.1027 381 139.62 373.005 195.068 365.509C250.516 358.014 309.43 ' +
    '351.139 367.766 317.037C426.103 282.935 527.18 163.625 571.077 117.152C614.973 ' +
    '70.6784 642.819 27.2034 701.611 17.7086C769.766 6.7016 936.111 10.7126 1072.42 ' +
    '10.7127';
export const MAC_CURVE_VIEW_BOX = '0 0 1073 392';
export const MAC_CURVE_STROKE_WIDTH = 20;

export interface MacStageMeta {
    name: string;
    detail: string;
}

export const MAC_STAGE_META: Record<MacStageKey, MacStageMeta> = {
    inception: { name: 'Inception', detail: 'fine dining, mixology, earliest stage' },
    adoption: { name: 'Adoption', detail: 'trendy restaurants + specialty grocers' },
    proliferation: { name: 'Proliferation', detail: 'chains + mainstream grocery' },
    ubiquity: { name: 'Ubiquity', detail: 'find it just about anywhere' },
};
